export default {
    title: 'Weitere öffentliche Mittel',
    addPublicFund: 'Eintrag hinzufügen',
    listing: {
        fundingBody: 'Zuwendungsgeber/in',
        fundingRequestedOrGrantedDate: 'bewilligt/beantragt',
        amount: 'Betrag',
    },
}